<template>
  <section class="pdf-viewer clearfix">
    <div class="ctrl-btns-row noprint">
      <el-button
        type="info"
        icon="el-icon-s-promotion"
        @click="sendEmailAction"
      >{{ $locale("pdf.sendEmail") }}</el-button>
      <el-button
        icon="el-icon-document"
        class="egl-btn-yellow"
        @click="generateReport"
      >{{ $locale("pdf.pdf") }}</el-button>
      <el-button
        type="info"
        icon="el-icon-printer"
        @click="printAction"
      >{{ $locale("pdf.print") }}</el-button>
    </div>

    <section class="pdf-container">
      <div class="content-preview">
        <vue-html2pdf
          :show-layout="converterSetting.showLayout"
          :float-layout="converterSetting.floatLayout"
          :enable-download="converterSetting.enableDownload"
          :preview-modal="converterSetting.previewModal"
          :paginate-elements-by-height="converterSetting.paginateElementsByHeight"
          :filename="converterSetting.filename"
          :pdf-quality="converterSetting.pdfQuality"
          :manual-pagination="converterSetting.manualPagination"
          :pdf-format="converterSetting.pdfFormat"
          :pdf-orientation="converterSetting.pdfOrientation"
          :pdf-content-width="converterSetting.pdfContentWidth"
          ref="html2Pdf"
          @startPagination="showLoading"
          @hasDownloaded="savePDFtoServer"
        >
          <section slot="pdf-content">
            <!-- PDF Content Here -->
            <slot></slot>
          </section>
        </vue-html2pdf>
      </div>
    </section>

  </section>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
/** 3rd party lib ref: https://github.com/kempsteven/vue-html2pdf */
import { Loading } from "element-ui";
import "./style.less";
import locale from "@/helpers/locale";

export default {
  name: "pdf-viewer",
  components: {
    VueHtml2pdf,
  },
  data() {
    return {
      converterSetting: {
        showLayout: this.showLayout,
        floatLayout: this.floatLayout,
        enableDownload: this.enableDownload,
        previewModal: this.previewModal,
        paginateElementsByHeight: this.paginateElementsByHeight,
        filename: this.filename,
        pdfQuality: this.pdfQuality,
        manualPagination: this.manualPagination,
        pdfFormat: this.pdfFormat,
        pdfOrientation: this.pdfOrientation,
        pdfContentWidth: this.pdfContentWidth,
      },
      loadingStatus: null,
      mediaQueryList: window.matchMedia("print"),
      matchMediaFn: null,
    };
  },
  props: {
    showLayout: {
      type: Boolean,
      default: true
    },
    floatLayout: {
      type: Boolean,
      default: false
    },
    enableDownload: {
      type: Boolean,
      default: true
    },
    previewModal: {
      type: Boolean,
      default: true
    },
    paginateElementsByHeight: {
      type: Number,
      default: 1120
    },
    filename: {
      type: String,
      default: () => locale("pdf.invoice")
    },
    pdfQuality: {
      type: Number,
      default: 2
    },
    manualPagination: {
      type: Boolean,
      default: true
    },
    pdfFormat: {
      type: String,
      default: "a4"
    },
    pdfOrientation: {
      type: String,
      default: "portrait"
    },
    pdfContentWidth: {
      type: String,
      default: "800px"
    }
  },
  mounted() {
    const afterPrint = () => {
      this.changePrintMode(false);
    };

    this.matchMediaFn = function(mql) {
      if (!mql.matches) {
        afterPrint();
      }
    };

    if (window.matchMedia) {
      this.mediaQueryList.addListener(this.matchMediaFn);
    }

    window.onafterprint = afterPrint;
  },
  destroyed() {
    this.mediaQueryList.removeListener(this.matchMediaFn);
    window.onafterprint = null;
  },
  methods: {
    /*
    ** Generate Report using refs and calling the
    ** refs function generatePdf()
    **/
    generateReport() {
      this.changePrintMode(true);
      this.$refs.html2Pdf.generatePdf();
    },
    sendEmailAction() {

    },
    printAction() {
      const that = this;
      this.changePrintMode(true);

      that.$nextTick(function() {
        window.print();
      });
    },
    showLoading() {
      this.loadingStatus = Loading.service({
        text: `${this.$locale("global.loading")}...`,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)"
      });
    },
    hideLoading() {
      if (this.loadingStatus) {
        this.loadingStatus.close();
        this.loadingStatus = null;
      }

      this.changePrintMode(false);
    },
    async changePrintMode(status) {
      await this.$refs.html2Pdf.$children[0].setPrintMode(status);
    },
    savePDFtoServer(blob) {
      const timestamp = this.$moment().valueOf();
      const pdfFile = new File([ blob ], `uploadPDF_${timestamp}.pdf`, { type: blob.type });
      console.log(`Saev upload_${timestamp}.pdf>> `, pdfFile);
      //TODO: upload PDF file to backend, and tirgger send email function.

      this.hideLoading();
    }
  },
};
</script>
